import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useVideo(id, section, params = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchForumThread() {
    setLoading(true);
    const { response, data } = await API.fetchForumThread(token, id, section, params);

    if (response.ok) {
      setResult(data);
      setLoading(false);
      setError(null);
    } else {
      setError({ status: response.status, ...data });
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchForumThread();
  }, [id, params, setResult, setLoading, setError]);

  return {
    loading,
    error,
    refresh: fetchForumThread,
    thread: result?.thread ?? null,
    posts: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
    pendingCount: result?.pendingCount ?? 0,
  };
}
